import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import Header from "../components/common/Header";
import SideBar from "../components/common/SideBar";
import { TrimText } from "../components/common/TrimText";
import AuditTrail from "../components/systemadministration/CampusManagement/AuditTrail";
import CampusBuildingDetails from "../components/systemadministration/CampusManagement/CampusBuildingDetails";
import CampusDetails from "../components/systemadministration/CampusManagement/CampusDetails";
import CampusList from "../components/systemadministration/CampusManagement/CampusList";
import RoomList from "../components/systemadministration/CampusManagement/RoomList";
import { GetCampusDetails } from "../services/CampusBuildingService";
import { GlobalIconNames } from "../utils/GlobalIconNames";
import Button from "../components/common/Button/Button";

const CampusManagement = (props) => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("");
  const location = useLocation();
  const { tab } = useParams();
  const search = useLocation().search;
  const campusId = new URLSearchParams(search).get("id");
  const [campusDetailsData, setCampusDetailsData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const campusName = campusDetailsData?.campus_name ?? new URLSearchParams(search).get("name");

  useEffect(() => {
    const fetchCampusDetails = async () => {
      if (campusId) {
        setIsLoading(true);
        try {
          const resCampusDetails = await GetCampusDetails(campusId);
          if (resCampusDetails.data?.campusDetails) {
            setCampusDetailsData(resCampusDetails.data.campusDetails);
          } else {
            console.error(`No data found for campusId:${campusId}`);
          }
        } catch (error) {
          console.error("Error fetching campus name:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchCampusDetails();
  }, [campusId]);

  useEffect(() => {
    setActiveTab(tab !== "" ? tab : "settings");
  }, [tab]);

  const isActive = (tabName) => {
    return (
      activeTab === tabName ||
      (tabName === "campusDetails" && (tab === "campusDetails" || tab === "addCampus")) ||
      (tabName === "campusList" && tab === "campusList")
    );
  };

  const getTabUrl = (targetTab) => {
    if (targetTab === "campusList") return "/administration/campusManagement/campusList";
    if (targetTab === "auditTrail") {
      return campusId === null
        ? "/administration/campusManagement/auditTrail"
        : `/administration/campusManagement/auditTrail?id=${campusId}&name=${encodeURIComponent(campusName || "")}`;
    }
    if (targetTab === "rooms") {
      return `/administration/campusManagement/rooms?id=${campusId}&name=${encodeURIComponent(campusName || "")}`;
    }
    return `/administration/campusManagement/campusDetails?id=${campusId}&name=${encodeURIComponent(campusName || "")}`;
  };

  return (
    <>
      <Header />
      <div className="content-wrapper d-flex flex-wrap">
        <SideBar />
        <div className="sidebar-right">
          <div className="sub-menu-content-block">
            <div className="sub-menu-right-block">
              <div className="wrap-box-right">
                {/* Header Section */}
                <div className="my-tickets-heading-blk flex-direction mb-2">
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="name-w-head d-flex align-items-center">
                      <h4 className="text-left-align landing-heading heading_color_dynamic">
                        {isLoading ? (
                          "Loading..."
                        ) : (
                          <>
                            {(tab === "campusList" || tab === "auditTrail") && !campusName
                              ? "Campus "
                              : tab === "addCampus"
                              ? "Add "
                              : "Campus: "}
                            <span title={campusName}>
                              {(tab === "campusList" || tab === "auditTrail") && !campusName
                                ? "Management"
                                : tab === "addCampus"
                                ? "Campus"
                                : (tab === "campusDetails" ||
                                    tab === "campusBuildingDetails" ||
                                    tab === "auditTrail" ||
                                    tab === "rooms") && campusName
                                ? TrimText(campusName, 60)
                                : ""}
                            </span>
                          </>
                        )}
                      </h4>
                    </div>

                    <div className="text-md-right action2-blk">
                      <div className="ticket-view-btn d-flex align-items-center">
                        {/* Back Button */}
                        <div className="add-new-ticket-bx">
                          <Button
                            variant="secondary"
                            iconLeft={<i className="fal fa-chevron-left" />}
                            onClick={() => history.goBack()}
                            title="Back"
                            className="campus-header-action-btn btn-white-bordered"
                          >
                            Back
                          </Button>
                        </div>

                        {/* Website Page Button - using Button component */}
                        {campusDetailsData?.websitePageUrl && (
                          <>
                            <div
                              style={{
                                width: "1px",
                                height: "37px",
                                background: "var(--colors-surface-border-divider, #DEE2E6)",
                                margin: "0 15px",
                                flexShrink: 0,
                              }}
                            />
                            <div className="add-new-ticket-bx">
                              <Button
                                variant="secondary"
                                iconLeft={<i className="fal fa-globe" />}
                                onClick={() => history.push(campusDetailsData.websitePageUrl)}
                                className="campus-header-action-btn btn-white-bordered"
                              >
                                Website Page
                              </Button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Tabs Section */}
                <div className="tabs-wrap">
                  {tab !== "addCampus" && (
                    <ul className="nav nav-pills mb-2" id="tabs" role="tablist">
                      {/* Details Tab */}
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            isActive("campusList") || isActive("campusDetails") ? "active" : ""
                          }`}
                          onClick={() => history.push(getTabUrl("campusDetails"))}
                        >
                          {campusId === null && (
                            <>
                              <i className="fal fa-list"></i>
                              Campus List
                            </>
                          )}
                          {campusId !== null && GlobalIconNames("Details").html}
                        </button>
                      </li>

                      {/* Rooms Tab */}
                      {campusId !== null && (
                        <li className="nav-item">
                          <button
                            className={`nav-link ${activeTab === "rooms" || tab === "rooms" ? "active" : ""}`}
                            onClick={() => history.push(getTabUrl("rooms"))}
                          >
                            <i className="fal fa-door-open"></i>
                            Rooms
                          </button>
                        </li>
                      )}

                      {/* Audit Trail Tab */}
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === "auditTrail" || tab === "auditTrail" ? "active" : ""}`}
                          onClick={() => history.push(getTabUrl("auditTrail"))}
                        >
                          <i className="fal fa-history"></i>
                          Audit Trail
                        </button>
                      </li>
                    </ul>
                  )}

                  {/* Tab Content Panels */}
                  <div className="tab-content" id="pills-tabContent">
                    <div className="tab-pane fade active show" id="pills-tab11" role="tabpanel">
                      {tab === "campusList" && <CampusList />}
                    </div>
                    <div className="tab-pane fade active show" id="pills-tab12" role="tabpanel">
                      {location.pathname.includes("/administration/campusManagement/auditTrail") && <AuditTrail />}
                    </div>
                    <div className="tab-pane fade active show" id="pills-tab14" role="tabpanel">
                      {tab === "rooms" && <RoomList />}
                    </div>
                    <div className="tab-pane fade active show" id="pills-tab12" role="tabpanel">
                      {(tab === "campusDetails" || tab === "addCampus") && (
                        <CampusDetails
                          campusId={campusId}
                          campusName={campusName}
                          campusDetailsData={campusDetailsData}
                          setCampusDetailsData={setCampusDetailsData}
                        />
                      )}
                      {tab === "campusBuildingDetails" && <CampusBuildingDetails />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .campus-header-action-btn {
          transition: all 0.2s ease;
        }
      `}</style>
    </>
  );
};

export default CampusManagement;
